import { LazyModule, createLazyComponent } from 'owa-bundling';
import type ProofingPlugin from './plugin/ProofingPlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "ProofingPlugin" */ './lazyIndex')
);

export type LazyProofingPlugin = LazyPlugin<ProofingPlugin>;

export let LazyProofingPluginClass = createLazyPlugin(
    lazyModule,
    m => m.ProofingPlugin,
    'Proofing',
    trigger
);

export let LazyProofingTeachingCallout = createLazyComponent(
    lazyModule,
    m => m.ProofingTeachingCallout
);

function trigger(evt: PluginEvent) {
    return (
        evt.eventType === PluginEventType.KeyUp ||
        evt.eventType === PluginEventType.MouseUp ||
        evt.eventType === PluginEventType.ContentChanged
    );
}
